// client/src/components/ProtectedRoute.jsx
import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, role } = useContext(AuthContext);

  // Still waiting for the auth check
  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  // If not authenticated, redirect to the appropriate login page
  if (!isAuthenticated) {
    const redirectPath = requiredRole === "admin" ? "/admin/login" : "/user/login";
    return <Navigate to={redirectPath} replace />;
  }

  // If a role is required and it doesn't match, redirect or show an error
  if (requiredRole && role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  // If everything is okay, render the protected component
  return children;
};

export default ProtectedRoute;
